import { render, staticRenderFns } from "./upload-dan-kamera.vue?vue&type=template&id=f1699432&scoped=true"
import script from "./upload-dan-kamera.vue?vue&type=script&lang=js"
export * from "./upload-dan-kamera.vue?vue&type=script&lang=js"
import style0 from "./upload-dan-kamera.vue?vue&type=style&index=0&id=f1699432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1699432",
  null
  
)

export default component.exports